import { ModeRectangles } from '@opentripplanner/transit-vehicle-overlay';
import { lowerize } from './string';

// a webpack null-loader is used for `transit-vehicle-overlay` during
// server side rendering because that package doesn't have SSR compatibility
// so `ModeRectangles` will be null during that process
const { LightRailVehicleRectangle, BusRectangle, DetailedRectangle } =
  typeof window !== 'undefined' ? ModeRectangles : {};

export const rectangleSymbols = [
  {
    getType: vehicle => vehicle.routeType,
    minZoom: 0,
    symbol: LightRailVehicleRectangle,
    symbolByType: {
      BUS: BusRectangle,
    },
  },
  {
    minZoom: 13,
    symbol: DetailedRectangle,
  },
];

/**
 * Make destination from a real-time vehicle record
 * @param {any} vehicle - Vehicle data
 * @param {boolean} pretty - Whether to format the destination nicely
 * @returns {string} Formatted destination
 */
export const destinationFromVehicleRecord = (vehicle, pretty = true) => {
  let destination = vehicle.routeLongName;

  // make destination sign pretty (ie lowercase 'to', remove bus # if it starts sign)
  if (pretty) {
    if (destination.startsWith(vehicle.routeShortName)) {
      destination = destination.replace(vehicle.routeShortName, '').trim();
    }
    if (destination.startsWith('To ')) {
      destination = lowerize(destination);
    }
  }

  return destination;
};

/**
 * Extract route label from vehicle properties
 * MAX lines just show "MAX" while other routes show route short name or ID
 *
 * @param {any} properties - Vehicle properties
 * @returns {string} Formatted route label
 */
export const getRouteLabel = properties => {
  if (!properties) return '';

  const MAX_LINE_PREFIX = 'MAX';

  return properties.routeShortName?.startsWith(MAX_LINE_PREFIX)
    ? MAX_LINE_PREFIX
    : properties.routeShortName ?? properties.routeId ?? '';
};

export default rectangleSymbols;
